export const defaultMeta = {
  count: 1,
  current_page: 1,
  per_page: 12,
  total: 0,
  total_pages: 0
}